import clsx from "clsx";
import Link from "next/link";

import getLink from "@/lib/storyblok/getLink";
import type { HeroCardStoryblok } from "@/types/blok-types";

import ImageTag from "@/components/atoms/ImageTag/ImageTag";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import sizes from "@/lib/utils/sizes";
import styles from "./hero-card.module.css";

/**
 * @param slides Number of HeroCard components in the parent blok
 */

const HeroCard = ({
  blok,
  slides,
  preview
}: {
  blok: HeroCardStoryblok;
  slides: number;
  preview: boolean;
}) => {
  const { image, Title, link, subtitle, tag } = blok;
  const uri = link ? getLink(link) : undefined;

  return (
    <Link href={uri ?? "#"} className={styles.root}>
      <div className={styles.image}>
        <StoryblokComponent
          blok={image?.[0]}
          sizes={sizes(95)}
          customAspect
          preview={preview}
        />
      </div>
      {tag && <ImageTag>{tag}</ImageTag>}
      <div className={clsx("hero-title", styles.title)}>{Title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
    </Link>
  );
};

export default HeroCard;
